export function Button({ children, onClick, className = "" }) {
    return (
      <button className={`px-4 py-2 bg-blue-500 text-white rounded ${className}`} onClick={onClick}>
        {children}
      </button>
    );
  }
  
  export function Card({ children, className = "" }) {
    return <div className={`bg-white shadow-md rounded p-4 ${className}`}>{children}</div>;
  }
  
  export function CardContent({ children }) {
    return <div className="p-4">{children}</div>;
  }
  
  export function Input({ type = "text", placeholder, value, onChange, className = "" }) {
    return (
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`border p-2 rounded w-full ${className}`}
      />
    );
  }
  
  export function Table({ children }) {
    return <table className="w-full border-collapse">{children}</table>;
  }
  
  export function TableHead({ children }) {
    return <thead className="bg-gray-200">{children}</thead>;
  }
  
  export function TableRow({ children }) {
    return <tr className="border-b">{children}</tr>;
  }
  
  export function TableCell({ children }) {
    return <td className="p-2 border">{children}</td>;
  }
  
  export function TableBody({ children }) {
    return <tbody>{children}</tbody>;
  }
  